var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.999,
    viewBox: "0 0 16 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.108.889l.022.022a3.049 3.049 0 0 1-.044 4.309L5.66 14.647a.686.686 0 0 1-.314.179L4.677 15a.685.685 0 0 1-.333.087l-3.487.893a.686.686 0 0 1-.835-.835l.893-3.487A.685.685 0 0 1 1 11.323l.172-.669a.686.686 0 0 1 .179-.314L10.794.9a3.051 3.051 0 0 1 4.314-.011zM1.985 13.01l-.346 1.351 1.35-.347zm6.632-8l-6.162 6.166-.075.29 2.152 2.152.29-.074 6.161-6.162zm1.828-1.828l-.858.858 2.368 2.368.858-.858zm1.321-1.32l-.017.017-.334.334 2.368 2.368.34-.339a1.679 1.679 0 0 0 .027-2.372l-.01-.01a1.679 1.679 0 0 0-2.374.006z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.aa47e83b.svg";
export { ForwardRef as ReactComponent };